import { PermitRequest } from "@components/resolvers/permit.resolvers";
import { BaseService } from "./base.service";
import { BaseResponse } from "./dtos/base.dto";
import { PermitResponse, PermitSettingResponse } from "./dtos/permit.dto";
import axios from "axios";

interface PermitServiceInterface {
  queries: {
    GET_PERMIT_DATA: string;
    GET_PERMIT_SETTING: string;
  };
  request(payload: PermitRequest): Promise<BaseResponse<boolean>>;
  data(limit: string): Promise<PermitResponse>;
  setting(payload: { prefix: string }): Promise<PermitSettingResponse>;
}
export const PermitService: PermitServiceInterface = {
  queries: {
    GET_PERMIT_DATA: "GET_PERMIT_DATA",
    GET_PERMIT_SETTING: "GET_PERMIT_SETTING",
  },
  request: async (payload: PermitRequest) => {
    try {
      // const request = await BaseService.request().post<BaseResponse<boolean>>(
      //   "/permit/request",
      //   payload
      // );
      const request = await axios.post<BaseResponse<boolean>>(
        `https://multiadmin.sipond.com/api/perizinan/request`,
        payload,
        {
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );
      return BaseService.response(request);
    } catch (error: unknown) {
      return BaseService.response(error, true);
    }
  },
  data: async (limit: string) => {
    try {
      const request = await BaseService.request().get<PermitResponse>(
        "/permit/data",
        { params: { limit } }
      );
      return BaseService.response(request);
    } catch (error: unknown) {
      return BaseService.response(error, true);
    }
  },
  setting: async (payload: { prefix: string }) => {
    try {
      const request = await axios.get<PermitSettingResponse>(
        `https://multiadmin.sipond.com/api/perizinan/setting`,
        {
          params: payload,
          headers: {
            token:
              "$2y$12$.ztMaYznNLvwXEBgQ6G.TunKw/ONAj9uTnCmBdsnnDXOkzikQxxBG",
          },
        }
      );
      return BaseService.response(request);
    } catch (error: unknown) {
      return BaseService.response(error, true);
    }
  },
};
